if ('serviceWorker' in navigator) {
    // The service-worker URL is assembled at runtime (not passed as a bare string
    // literal) so Parcel 1.x's build-time static analysis of
    // navigator.serviceWorker.register('<literal>') does NOT treat it as a local
    // asset to resolve/bundle. The real file (dist/qpp-ng-landing-sw.js) is emitted
    // later by the separate `build:sw` step (workbox generateSW), so resolving it at
    // parcel-build time fails with ENOENT. Keeping the argument non-literal disables
    // that detector while the resolved runtime path stays exactly '/qpp-ng-landing-sw.js'.
    // NOTE: package.json's `externals: {"/qpp-ng-landing-sw.js": false}` (via
    // parcel-plugin-html-externals) does NOT cover this — that plugin only marks URLs
    // referenced from index.html MARKUP as external; it never sees this runtime JS
    // `register()` call, which Parcel core's own asset resolver (not the HTML plugin)
    // statically detects. So the non-literal assembly is still required here.
    const swUrl = '/qpp-ng-landing-sw' + '.js';
    navigator.serviceWorker.register(swUrl).then((registration) => {
        console.debug('Service worker registration succeeded:', registration);
    }, (error) => {
        console.error(`Service worker registration failed: ${error}`);
    });
} else {
    console.error('Service workers are not supported.');
}
